module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2OmVa"))).then(() => parcelRequire('hEqeo'));